const config = {
    appName: 'Bookish Melodies',
};

export default config;
